import React from "react";
import { ReactComponent as BackIcon } from "assets/img/svg/BackButton.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import RefundTypeDropdown from "./refundTypeDropdown/Dropdown";
import { useWizard } from "../../../../../components/wizard/WizardContext";

const WizardTopHeader = ({
  backIconClickHandler = () => {
    window.close();
  },
}) => {

  const { current, next, updateValues } = useWizard();

  return (
    <div
      className="remove-container-top-space mb-4 d-flex heading-4 color-dark align-items-center justify-content-between top-header-collect-payment"
    >
      <div className="d-flex align-items-center">
        <IconButtonWrapper
          onClick={() => {
            backIconClickHandler();
            updateValues("selectedStudent", "");
            next(0)
          }
          }>
          <BackIcon />
        </IconButtonWrapper>
        <div>Create Refund Request</div>
      </div>
      {current === 0 && <RefundTypeDropdown />}
    </div>
  );
};

export default WizardTopHeader;
